// extracted by mini-css-extract-plugin
export default {"stakeContainer":"_2Dyq-","stakeItem":"_3nAQZ","smallContent":"_17oX5","innerLineStake":"_42-pY"};